import {whitelist} from "validator";

export const toNumber = (value) => {
    return whitelist(value, '0123456789-');
};

export const toFloat = (value) => {
    return whitelist(value, '0123456789\\.-');
};
